import React, { useEffect, useState, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import DeleteIcon from '@assets/icons/deleteIcon';
import OpenInEditorIcon from '@assets/icons/openInEditorIcon';
import CopyMenuIcon from '@assets/icons/copyMenuIcon';
import EditBrandIcon from '@assets/icons/editBrandIcon';
import { getLabelsFromSection } from '@utils/brand';
import { useLocation } from "react-router-dom";

const Menu:React.FC<IProps> = (props) => {
  const [totalOffSetTop, setTotalOffSetTop]=useState(0);
  const [viewAllPage, setViewAllPage]=useState(false);
  const spaceMenuY = props.section==="colors" ? 160 : 300;
  
  const useOutsideAlerter = (ref:any) => {
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {
          props.setOpen(false);
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  const optionsRef = useRef(null);
  useOutsideAlerter(optionsRef);

  useEffect(() => {
    if(optionsRef && optionsRef.current){
      let element: any = optionsRef.current
      if (location.pathname==="/brand-library") {
        let offsetTop = 0;
        while (element && !(element.id as string).startsWith("preview-component-") && !(element.id as string).startsWith("main-preview-component-")) {
          element = element.parentElement;
        }
        if (element && element.offsetTop) {
          offsetTop = element.offsetTop;
        }
        setTotalOffSetTop(offsetTop);
        if (element)
        {
          while (element && !(element.id as string).startsWith("infinite-scroll-")) {
            element = element.parentElement;
          }
          if (element && (element.id as string).startsWith("infinite-scroll-"))
          {
            setViewAllPage(true);
          }
        }
      }
    }
  }, [optionsRef]);

  const handleMetadata = () => {
    props.onActions("METADATA");
    props.setOpen(false);
  }

  const handleReplace = () => {
    props.onActions("REPLACE");
    props.setOpen(false);
  }

  const handleDelete = () => {
    props.onActions("DELETE");
    props.setOpen(false);
  }

  let location = useLocation();

  const returnLeftValue = () => {
    var value = props.coordinates.x;
    if (location.pathname==="/brand-library") {
      value -= 550;
      if (viewAllPage) {
        value += 100;
      }
      if (value + 950 > window.innerWidth) {
        value -= 335;
      }
    }
    return value;
  }

  const returnTopValue = () => {
    var value = 0;
    if (location.pathname==="/brand-library") {
      value = totalOffSetTop - 120;
    }
    return value;
  }


  const elementName = getLabelsFromSection(props.labels.elementName); 

  return (
    <S.Root 
      ref={optionsRef}
      leftValue={`${returnLeftValue()}px`}
      topValue={`${returnTopValue()}px`}
    >
      {
        props.open &&
        <S.PopupContainer minHeight={props.section==="colors" ? 200 : 315}>
          <S.Title>
            {props.labels.name}
          </S.Title>
          <S.DescriptionContainer>
            <S.Description>
              {`Last Edited: ${props.labels.lastEditedDate}`}
            </S.Description>
            {(elementName.toLowerCase()==="logo" || elementName.toLowerCase()==="background image") &&
              <>
                <S.Description>
                  {`Type: ${props.labels.type}`}
                </S.Description>
                <S.Description>
                  {props.labels.tags?.length>0 &&
                  `Tags: ${props.labels.tags.map((tag:string)=>` ${tag}`)}`}
                </S.Description>
              </>
            }
            { elementName.toLowerCase()==="stock image" &&
              <>
                <S.Description>
                  {`Metadata: ${props.labels.themes}`}
                </S.Description>
                <S.Description>
                  {props.labels.type}
                </S.Description>
              </>
            }
            { elementName.toLowerCase()==="font" && 
              <>
                <S.Description>
                  {`Alias: ${props.labels.aliases?.length ? props.labels.aliases.join(", ") : ""}`}
                </S.Description>
              </>
            }
            {
              (elementName.toLowerCase()==="vehicle image" && props.section!=="colors" ) &&
              <>
                <S.Description>
                  {`Metadata: ${props.labels.tags.map((tag:string)=>` ${tag}`)}`}
                </S.Description>
              </>
            }
          </S.DescriptionContainer>
          {props.section!=="colors" &&
          <>
            <S.TopOptionsContainer>
              <S.OptionContainer
                onClick={handleReplace}
              >
                <S.OptionIconContainer>
                  <CopyMenuIcon/>
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Replace ${elementName}`}
                </S.OptionText>
              </S.OptionContainer>    
              <S.OptionContainer
                onClick={handleMetadata}
              >
                <S.OptionIconContainer>
                  <EditBrandIcon/>
                </S.OptionIconContainer>
                <S.OptionText>
                  {`Edit ${elementName !== "Font" ? `Metadata` : `Alias`}`}
                </S.OptionText>
              </S.OptionContainer>                   
            </S.TopOptionsContainer>
            <S.Divider />
          </>}
          <S.BottomOptionsContainer>
            <S.OptionContainer
              onClick={handleDelete}
            >
              <S.OptionIconContainer>
                <DeleteIcon />
              </S.OptionIconContainer>
              <S.OptionText>
                {`Delete ${elementName}`}
              </S.OptionText>
            </S.OptionContainer>
          </S.BottomOptionsContainer>
        </S.PopupContainer>
      }
    </S.Root>
  );
}

export default Menu;